import styled, { CSSProperties } from 'styled-components';
import { Icon } from './Icon';
import IconCheckmark from '../../../public/icons/checkmark.svg?react';

const StyledCheckboxContainer = styled.div<{ $disabled: boolean; $active: boolean }>`
	width: 2.6rem;
	height: 2.6rem;
	display: flex;
	justify-content: center;
	align-items: center;

	border-radius: 6px;
	border: 1px solid ${({ theme }) => theme.checkbox_border};
	background-color: ${({ theme }) => theme.checkbox_bg};
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	transition: 0.3s all !important;
	${({ $disabled }) => $disabled && 'opacity: 0.4;'}
	> div {
		margin: auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

interface CheckboxProps {
	style?: CSSProperties;
	disabled?: boolean;
	onChange: (value: boolean | null) => void;
	value: boolean | null;
}
export function Checkbox(props: CheckboxProps) {
	const { disabled: disabledProp, value, onChange, style } = props;

	const toggleActive = () => {
		if (!disabledProp) {
			onChange(value === null ? true : !value);
		}
	};

	return (
		<StyledCheckboxContainer
			$active={value === true}
			onClick={toggleActive}
			$disabled={typeof disabledProp === 'boolean' ? disabledProp : false}
			style={style && style}
		>
			<Icon $colorFill="checkbox_fg" style={{ height: 8, opacity: value ? 1 : 0 }}>
				<IconCheckmark />
			</Icon>
		</StyledCheckboxContainer>
	);
}
